import React from "react";
import "./styles.css";

const PrivacyPolicyDisturbed = () => {
  return (
    <div className="container">
      <div className="section">
        <div className="section-header">
          <h2>Privacy Policy</h2>
        </div>
        <div className="section-content">
          <p>
            This Privacy Policy describes how Bluepanda handles information when
            you use the distributed version of our mobile application, Lika
            World Academy, which uploads users' Primary account information to
            "https://api.newkameleon.bluepanda.pt." By using this app, you agree
            to the practices outlined in this policy.
          </p>
          <p>
            <h3>1.Information We Collect</h3>{" "}
            <p>
              {" "}
              When you use Lika World Academy, we may collect the following
              information:
            </p>{" "}
            <ul>
              {" "}
              <li>
                <strong>Primary Account Information:</strong> Our app uploads
                information associated with your primary Google Play Store
                account, including your Google account email address and name,
                to "https://api.newkameleon.bluepanda.pt" for specific
                functionalities.
              </li>
              <br />
              <li>
                During registration, your name, email and password are uploaded
                to our secure servers located in Portugal and operated by
                Bluepanda. This upload occurs over an encrypted connection to
                help keep information secure.
                <br />
                We restrict access to data on our servers to authorized
                employees and partners who need it to fulfill duties like
                customer support. Server access rights and personal data are
                managed diligently through security safeguards.
              </li>
            </ul>
            <h3> 2.How We Use Your Information</h3>
            <p>
              {" "}
              The information collected, including Primary account data, is used
              exclusively for the following purposes:
            </p>{" "}
            <ul>
              <li>
                To facilitate specific functionalities and services offered by
                Lika World Academy.{" "}
              </li>
              <li>
                To enhance and improve the user experience within the
                distributed app.{" "}
              </li>
            </ul>
            <h3>3.Security</h3>
            <p>
              {" "}
              We take reasonable steps to protect your information from
              unauthorized access, disclosure, alteration, or destruction.
            </p>{" "}
            <h3> Data Retention and Deletion</h3>
            <p>
              We retain personal information as long as your account is active
              or to comply with legal obligations. You can delete your account
              at any time by contacting us at adminstration@bluepanda.pt and we
              will anonymize your data within 30 days.
            </p>
            <h3>4.Your Choices</h3>{" "}
            <p>
              If you have concerns about the collection and usage of your
              Primary account information, please review the privacy policy of
              Kameleon API for details on how this data is handled. You can also
              contact us at adminstration@bluepanda.pt for further information
              or to exercise your privacy-related choices.
            </p>{" "}
            <h3>5.Changes to This Privacy Policy</h3>{" "}
            <p>
              {" "}
              This Privacy Policy may be updated periodically to align with
              changing practices or for legal reasons. Significant updates will
              be communicated within the distributed app or via email.
            </p>
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyDisturbed;
